// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".error-page[data-v-fa3024e6]{min-width:800px}.error-img[data-v-fa3024e6]{display:block;max-width:100px;margin:15px auto}#wrap[data-v-fa3024e6]{width:100%;height:100%;position:relative}#wrap .box[data-v-fa3024e6]{position:absolute;left:50%;top:50%;margin-left:-400px;margin-top:-200px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
